document.addEventListener("DOMContentLoaded", () => {

  const sticky = document.getElementById("StickyATC");
  if (!sticky) return;

  const productForm = document.querySelector("product-form");
  if (!productForm) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          sticky.classList.remove("show");
        } else {
          sticky.classList.add("show");
        }
      });
    },
    {
      threshold: 0
    }
  );

  observer.observe(productForm);

  const originalButton = productForm.querySelector('button[type="submit"]');
  const stickyButton = document.getElementById("StickyATCButton");

  if (originalButton && stickyButton) {
    stickyButton.addEventListener("click", () => {
      originalButton.click();
    });
  }

});